import SearchPopup from '@entities/channel/ui/search-popup'
import { IconsSb, IconsSb2, IconsSb3, IconsSb4 } from '@entities/channel/ui/svgs'
import LaptopImage from '@shared/assets/laptop.png'
import { Radio } from '@shared/ui/radio/radio'
import type { FormProps } from 'antd'
import { Avatar, Button, Col, Flex, Form, Image, Input, Row, Space, Typography } from 'antd'
import { Popup } from 'antd-mobile'
import { useEffect, useState } from 'react'
import { categories } from '../model/data/categories'
import { countries } from '../model/data/countries'
import { languages } from '../model/data/languages'
import { timezones } from '../model/data/timezones'
import { useChannels } from '../model/hooks/use-channels'
import { InternetRecourceType } from '../model/types'
import './styled.css'

const { Text, Title } = Typography

interface AddChannelMobileModalProps {
    open: boolean
    onClose: () => void
}

export type FieldType = {
    username: string
    language: string
    country: string
    category: string
    timezone: string
    type: InternetRecourceType
    url: string
    name: string
}

const BOT_USERNAME = process.env.BOT_USERNAME || ''

export const AddChannelMobileModal = ({ open, onClose }: AddChannelMobileModalProps) => {
    const [addChannelPopup, setAddChannelPopup] = useState(false)
    const [addSitePopup, setAddSitePopup] = useState(false)
    const [openCategoryModal, setOpenCategoryModal] = useState(false)
    const [openLangModal, setOpenLangModal] = useState(false)
    const [openCountryModal, setOpenCountryModal] = useState(false)
    const [openTimeZoneModal, setOpenTimeZoneModal] = useState(false)
    const {
        tempChannel,
        actions: { createChannel, refetchTempChannel },
        createChannelIsLoading
    } = useChannels()

    const [selectedResource, setSelectedResource] = useState(InternetRecourceType.channel)

    const onFinish: FormProps<FieldType>['onFinish'] = async (values) => {
        await createChannel({
            ...values,
            username:
                selectedResource === InternetRecourceType.channel
                    ? tempChannel?.username || values.username
                    : undefined,
            type: selectedResource
        })
        onClose()
    }

    const [form] = Form.useForm()

    const [internetResourceSelected, setInternetResourceSelected] = useState(false)

    useEffect(() => {
        form.resetFields()
        setInternetResourceSelected(false)
    }, [form, open])

    useEffect(() => {
        if (selectedResource !== InternetRecourceType.channel || tempChannel) return

        let attempts = 0
        const maxAttempts = 10

        const interval = setInterval(() => {
            if (attempts >= maxAttempts) {
                clearInterval(interval)
                return
            }
            refetchTempChannel()
            attempts++
        }, 2000)

        return () => clearInterval(interval)
    }, [form, refetchTempChannel, selectedResource, tempChannel])

    const filedValues = form.getFieldsValue()
    const langLabel = languages.find((item) => item.value === filedValues?.language)?.label
    const categoryLabel = categories.find((item) => item.value === filedValues?.category)?.label
    const countryLabel = countries.find((item) => item.value === filedValues?.country)?.label
    const timezoneLabel = timezones.find((item: { value: string }) => item.value === filedValues?.timezone)
    const isDisabled =
        selectedResource === InternetRecourceType.channel
            ? (tempChannel?.username || filedValues?.username) &&
              langLabel &&
              categoryLabel &&
              countryLabel &&
              timezoneLabel
            : filedValues?.url && langLabel && categoryLabel && countryLabel

    return (
        <div className={'mobile-modal'}>
            <Popup visible={open} onMaskClick={onClose} onClose={onClose} bodyStyle={{ background: '#F0F3F5' }}>
                <Form
                    style={{
                        backgroundColor: '#eff3f6',
                        // height: '100vh',
                        overflowY: 'scroll',
                        padding: '20px',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        '&::-webkit-scrollbar': {
                            display: 'none'
                        }
                    }}
                    form={form}
                    name="add-channel"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    onFinish={onFinish}
                >
                    {internetResourceSelected && (
                        <Title
                            level={3}
                            style={{
                                margin: '0 0 20px 0',
                                textAlign: 'center'
                            }}
                        >
                            Подключение {selectedResource === InternetRecourceType.channel ? 'канала' : 'сайта'}
                        </Title>
                    )}
                    {internetResourceSelected && (
                        <Flex gap={14} align="center" justify="center" style={{ marginBottom: '24px' }}>
                            {tempChannel ? (
                                <>
                                    <Avatar
                                        src={
                                            selectedResource === InternetRecourceType.channel
                                                ? `data:image/jpeg;base64,${tempChannel?.photoUrl}`
                                                : `${filedValues?.url}/favicon.ico`
                                        }
                                    />
                                    <Text>
                                        {selectedResource === InternetRecourceType.channel
                                            ? tempChannel?.username || tempChannel?.name
                                            : 'сайт'}
                                    </Text>
                                </>
                            ) : (
                                <Text>Не удалось добавить канал, введите ссылку на канал в поле ниже</Text>
                            )}
                        </Flex>
                    )}

                    {!internetResourceSelected && (
                        <Flex
                            align="center"
                            gap={6}
                            style={{
                                padding: '15px 10px',
                                background: '#fff',
                                borderRadius: '8px',
                                marginBottom: '15px'
                            }}
                        >
                            <Image src={LaptopImage} width={120} alt="Ноутбук" />
                            <Text>Выберите тип интернет-ресурса</Text>
                        </Flex>
                    )}

                    <Row gutter={[16, 16]}>
                        {!internetResourceSelected && (
                            <Col span={24}>
                                <Form.Item name="type" initialValue={selectedResource}>
                                    <Radio.Group
                                        onChange={(e) => setSelectedResource(e.target.value)}
                                        style={{ width: '100%', borderRadius: '12px', overflow: 'hidden' }}
                                    >
                                        <Radio
                                            value="channel"
                                            style={{
                                                backgroundColor: '#fff',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                flexDirection: 'row-reverse',
                                                padding: '8px 15px',
                                                fontSize: '17px',
                                                marginRight: 0,
                                                borderBottom: '0.5px solid #C8C7CC'
                                            }}
                                        >
                                            <Space size={16}>
                                                <div style={{ color: '#7C9BAD' }}>
                                                    <IconsSb />
                                                </div>
                                                Канал
                                            </Space>
                                        </Radio>
                                        <Radio
                                            style={{
                                                backgroundColor: '#fff',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                flexDirection: 'row-reverse',
                                                padding: '8px 15px',
                                                fontSize: '17px',
                                                marginRight: 0
                                            }}
                                            value="site"
                                        >
                                            <Space size={16}>
                                                <div style={{ color: '#7C9BAD' }}>
                                                    <IconsSb2 />
                                                </div>
                                                Сайт
                                            </Space>
                                        </Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                        )}

                        {internetResourceSelected && (
                            <>
                                <Space.Compact direction="vertical" style={{ width: '100%' }}>
                                    {selectedResource === InternetRecourceType.site && (
                                        <Button
                                            onClick={() => setAddSitePopup(true)}
                                            style={{
                                                borderTopLeftRadius: 12,
                                                borderTopRightRadius: 12,
                                                width: '100%',
                                                paddingTop: 0,
                                                paddingBottom: 0,
                                                height: 50,
                                                backgroundColor: 'white',
                                                borderTop: 'none',
                                                borderLeft: 'none',
                                                borderRight: 'none',
                                                color: '#919191',
                                                fontSize: '17px'
                                            }}
                                        >
                                            <Flex justify={'space-between'} align={'center'} style={{ width: '100%' }}>
                                                <Flex gap={10} align={'center'}>
                                                    <IconsSb />
                                                    <span>
                                                        {filedValues.url
                                                            ? `${filedValues.url}`
                                                            : 'Введите ссылку на сайт'}
                                                    </span>
                                                </Flex>
                                                <Flex gap={10} align={'center'}>
                                                    <IconsSb4 />
                                                </Flex>
                                            </Flex>
                                        </Button>
                                    )}

                                    {selectedResource === InternetRecourceType.channel && !tempChannel && (
                                        <Button
                                            onClick={() => setAddChannelPopup(true)}
                                            style={{
                                                borderTopLeftRadius: 12,
                                                borderTopRightRadius: 12,
                                                width: '100%',
                                                paddingTop: 0,
                                                paddingBottom: 0,
                                                height: 50,
                                                backgroundColor: 'white',
                                                borderTop: 'none',
                                                borderLeft: 'none',
                                                borderRight: 'none',
                                                color: '#919191',
                                                fontSize: '17px'
                                            }}
                                        >
                                            <Flex justify={'space-between'} align={'center'} style={{ width: '100%' }}>
                                                <Flex gap={10} align={'center'}>
                                                    <IconsSb />
                                                    <span>
                                                        {filedValues.username
                                                            ? `${filedValues.username}`
                                                            : 'Введите ссылку на канал'}
                                                    </span>
                                                </Flex>
                                                <Flex gap={10} align={'center'}>
                                                    <IconsSb4 />
                                                </Flex>
                                            </Flex>
                                        </Button>
                                    )}

                                    <Button
                                        onClick={() => setOpenLangModal(true)}
                                        style={{
                                            width: '100%',
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                            height: 50,
                                            backgroundColor: 'white',
                                            borderLeft: 'none',
                                            borderRight: 'none',
                                            borderBottom: 'none',
                                            color: '#919191',
                                            fontSize: '17px'
                                        }}
                                    >
                                        <Flex justify={'space-between'} align={'center'} style={{ width: '100%' }}>
                                            <Flex gap={10} align={'center'}>
                                                <IconsSb2 />
                                                <span>{langLabel ? `${langLabel} (Язык)` : 'Язык'}</span>
                                            </Flex>
                                            <IconsSb4 />
                                        </Flex>
                                    </Button>
                                    <Button
                                        style={{
                                            width: '100%',
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                            height: 50,
                                            backgroundColor: 'white',
                                            borderBottom: 'none',
                                            borderLeft: 'none',
                                            borderRight: 'none',
                                            color: '#919191',
                                            fontSize: '17px'
                                        }}
                                        onClick={() => setOpenCountryModal(true)}
                                    >
                                        <Flex justify={'space-between'} align={'center'} style={{ width: '100%' }}>
                                            <Flex gap={10} align={'center'}>
                                                <IconsSb2 />
                                                <span>{countryLabel ? `${countryLabel} (Страна)` : 'Страна'}</span>
                                            </Flex>
                                            <IconsSb4 />
                                        </Flex>
                                    </Button>
                                    {selectedResource === InternetRecourceType.channel && (
                                        <Button
                                            onClick={() => setOpenTimeZoneModal(true)}
                                            style={{
                                                width: '100%',
                                                paddingTop: 0,
                                                paddingBottom: 0,
                                                height: 50,
                                                backgroundColor: 'white',
                                                borderBottom: 'none',
                                                borderLeft: 'none',
                                                borderRight: 'none',
                                                color: '#919191',
                                                fontSize: '17px'
                                            }}
                                        >
                                            <Flex justify={'space-between'} align={'center'} style={{ width: '100%' }}>
                                                <Flex gap={10} align={'center'}>
                                                    <IconsSb2 />
                                                    <span>
                                                        {timezoneLabel
                                                            ? `${timezoneLabel.value} (ваш часовой пояс)`
                                                            : 'Часовой пояс'}
                                                    </span>
                                                </Flex>
                                                <IconsSb4 />
                                            </Flex>
                                        </Button>
                                    )}

                                    <Button
                                        onClick={() => setOpenCategoryModal(true)}
                                        style={{
                                            width: '100%',
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                            height: 50,
                                            backgroundColor: 'white',
                                            borderLeft: 'none',
                                            borderRight: 'none',
                                            borderBottomRightRadius: 12,
                                            borderBottomLeftRadius: 12,
                                            color: '#919191',
                                            fontSize: '17px'
                                        }}
                                    >
                                        <Flex justify={'space-between'} align={'center'} style={{ width: '100%' }}>
                                            <Flex gap={10} align={'center'}>
                                                <IconsSb3 />
                                                <span>
                                                    {categoryLabel ? `${categoryLabel} (Категория)` : 'Категория'}
                                                </span>
                                            </Flex>
                                            <IconsSb4 />
                                        </Flex>
                                    </Button>
                                    <Button
                                        style={{ borderRadius: 10, height: 52, marginTop: 14 }}
                                        type="primary"
                                        block
                                        size="large"
                                        disabled={!isDisabled}
                                        onClick={() => form.submit()}
                                        loading={createChannelIsLoading}
                                    >
                                        Добавить
                                    </Button>
                                </Space.Compact>
                            </>
                        )}

                        <Col span={24}>
                            {!internetResourceSelected && (
                                <Button
                                    style={{ borderRadius: 10, height: 52, marginTop: 14 }}
                                    type="primary"
                                    block
                                    size="large"
                                    onClick={() => {
                                        if (selectedResource === InternetRecourceType.channel) {
                                            const isIOS = Telegram.WebApp.platform === 'ios'

                                            const link = `https://t.me/${BOT_USERNAME}?startchannel&admin=change_info+post_messages+edit_messages+delete_messages+invite_users+pin_messages`

                                            Telegram.WebApp.openTelegramLink(link)
                                        }

                                        setTimeout(() => {
                                            setInternetResourceSelected(true)
                                        }, 1000)
                                    }}
                                >
                                    Продолжить
                                </Button>
                            )}
                        </Col>
                    </Row>

                    <Popup
                        style={{ borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
                        visible={addSitePopup}
                        onMaskClick={() => setAddSitePopup(false)}
                    >
                        <div style={{ height: '70vh', overflowY: 'scroll', padding: '20px' }}>
                            <Title level={3} style={{ textAlign: 'center' }}>
                                Добавьте сайт
                            </Title>
                            <Form.Item<FieldType>
                                style={{ margin: 0 }}
                                name="url"
                                required={false}
                                rules={[{ required: true, message: 'Обязательное поле' }]}
                            >
                                <Input style={{ width: '100%', height: 52, margin: 0, border: 'none' }} />
                            </Form.Item>
                            <Text
                                style={{
                                    color: '#707070',
                                    marginTop: 5,
                                    marginBottom: 20,
                                    display: 'inline-block'
                                }}
                            >
                                Введите ссылку на сайт в поле ниже.
                            </Text>
                            <Button
                                onClick={() => setAddSitePopup(false)}
                                type={'primary'}
                                style={{ width: '100%', height: 52, borderRadius: 10 }}
                            >
                                Добавить
                            </Button>
                        </div>
                    </Popup>
                    <Popup
                        style={{ borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
                        visible={addChannelPopup}
                        onMaskClick={() => setAddChannelPopup(false)}
                    >
                        <div style={{ height: '70vh', overflowY: 'scroll', padding: '20px' }}>
                            <Title level={3} style={{ textAlign: 'center' }}>
                                Добавьте ссылку на канал
                            </Title>
                            <Form.Item<FieldType>
                                style={{ margin: 0 }}
                                name="username"
                                required={false}
                                rules={[{ required: true, message: 'Обязательное поле' }]}
                            >
                                <Input style={{ width: '100%', height: 52, margin: 0, border: 'none' }} />
                            </Form.Item>
                            <Text
                                style={{
                                    color: '#707070',
                                    marginTop: 5,
                                    marginBottom: 20,
                                    display: 'inline-block'
                                }}
                            >
                                Введите юзернейм или ссылку на канал в поле ниже.
                            </Text>
                            <Button
                                onClick={() => setAddChannelPopup(false)}
                                type={'primary'}
                                style={{ width: '100%', height: 52, borderRadius: 10 }}
                            >
                                Добавить
                            </Button>
                        </div>
                    </Popup>
                    <SearchPopup
                        visible={openLangModal}
                        onSelect={(value) => form.setFieldsValue({ language: value })}
                        onClose={() => setOpenLangModal(false)}
                        onClick={() => setOpenLangModal(false)}
                        name="language"
                        data={languages}
                    />
                    <SearchPopup
                        onSelect={(value) => form.setFieldsValue({ country: value })}
                        visible={openCountryModal}
                        onClose={() => setOpenCountryModal(false)}
                        onClick={() => setOpenCountryModal(false)}
                        name="country"
                        data={countries}
                    />
                    <SearchPopup
                        onSelect={(value) => form.setFieldsValue({ category: value })}
                        visible={openCategoryModal}
                        onClose={() => setOpenCategoryModal(false)}
                        onClick={() => setOpenCategoryModal(false)}
                        name="category"
                        data={categories}
                    />
                    <SearchPopup
                        onSelect={(value) => form.setFieldsValue({ timezone: value })}
                        visible={openTimeZoneModal}
                        onClose={() => setOpenTimeZoneModal(false)}
                        onClick={() => setOpenTimeZoneModal(false)}
                        name="timezone"
                        data={timezones.map((item) => ({ value: item.value, label: item.label, hint: item.hint }))}
                    />
                </Form>
            </Popup>
        </div>
    )
}
